export * from './pager.service';


// WEBPACK FOOTER //
// ./src/app/_services/index.ts